// @flow

// LandingPage Saga Constants
export const LANDING_PAGE_TESTIMONIALS_REQUEST: string = "LANDING_PAGE_TESTIMONIALS_REQUEST";
export const LANDING_PAGE_TESTIMONIALS_SUCCESS: string = "LANDING_PAGE_TESTIMONIALS_SUCCESS";
export const LANDING_PAGE_TESTIMONIALS_FAILURE: string = "LANDING_PAGE_TESTIMONIALS_FAILURE";
export const LANDING_PAGE_LOGOS_REQUEST: string = "LANDING_PAGE_LOGOS_REQUEST";
export const LANDING_PAGE_LOGOS_SUCCESS: string = "LANDING_PAGE_LOGOS_SUCCESS";
export const LANDING_PAGE_LOGOS_FAILURE: string = "LANDING_PAGE_LOGOS_FAILURE";



// WEBPACK FOOTER //
// ./src/Constants/PublicPages/publicPagesConstants.js